import cookie from 'js-cookie';

import { toastError, tryParseJSON, removeStorageApplication, clearRelatedLocalCartLocalStorage } from '../utils';
import { callApi } from '../apiCaller';
import {
     API_AUTH_SIGN_OUT,
     AUTH_PATH,
     COOKIE_NAMES,
     DEFAULT_FN,
     ENV_OBJ,
     LOCAL_DIRECT_PATH,
     LOCAL_LOGIN_AS_SESSION,
     LOCAL_ORG_USER,
     LOCAL_USER_ROLE,
     MY_LEARNING_PATH,
     SYSTEM_ADMIN_PATH,
     USER_ROLES,
} from '../constants';

import { API_SYSTEM_ADMIN_USER_LOGIN_AS_SESSION_DETAIL } from '../components/Auth/actions';

const domain = ENV_OBJ[process.env.REACT_APP_ENV] ?? '';

// Access user info from cookie
export const isAuth = () => {
     if (window === 'undefined') return false;

     const isLoggedIn = cookie.get(COOKIE_NAMES.TP_IS_LOGGED_IN);
     return Boolean(isLoggedIn);
};

export const authenticateLoginAs = (response, next = DEFAULT_FN) => {
     const { token, user } = response.data;
     var inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000);

     const tokenOptions = { expires: inFiveMinutes };

     if (window.location.hostname !== 'localhost') {
          tokenOptions.domain = domain;
     }

     cookie.set(COOKIE_NAMES.TP_IS_LOGGED_IN, token, tokenOptions);
     if (user) {
          localStorage.setItem('user', JSON.stringify(user));
     }
     next();
};

export const signOut = async (redirect = true, callBack = DEFAULT_FN) => {
     const pathName = window.location.pathname;
     const orgUserLocal = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));
     const userRoleLocal = localStorage.getItem(LOCAL_USER_ROLE);
     const directPath = localStorage.getItem(LOCAL_DIRECT_PATH);

     const adminRoles = [USER_ROLES.SYSTEM_ADMIN, USER_ROLES.SYSTEM_ADMIN_LOWER];
     const isAdminRole = adminRoles.includes(userRoleLocal);

     const organizationId = orgUserLocal.organizationId;
     const fullPathOrg = pathName + (organizationId ? `?organizationId=${organizationId}` : '');
     const fullPathIndividual = directPath.includes('email') ? directPath : MY_LEARNING_PATH.DASHBOARD;

     // Delete login as session while it still exists
     const localLoginAsSession = tryParseJSON(localStorage.getItem(LOCAL_LOGIN_AS_SESSION));
     if (localLoginAsSession.id) {
          await callApi(API_SYSTEM_ADMIN_USER_LOGIN_AS_SESSION_DETAIL.replace(':id', localLoginAsSession.id), 'DELETE');
     }

     return await callApi(API_AUTH_SIGN_OUT, 'POST', null).then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return;
          }

          clearRelatedLocalCartLocalStorage();
          removeStorageApplication();

          if (pathName.includes('checkout') || pathName.includes('cart')) {
               localStorage.setItem(LOCAL_DIRECT_PATH, MY_LEARNING_PATH.DASHBOARD);
          } else {
               if (isAdminRole) {
                    localStorage.setItem(LOCAL_DIRECT_PATH, SYSTEM_ADMIN_PATH.DASHBOARD);
               } else if (orgUserLocal) {
                    localStorage.setItem(LOCAL_DIRECT_PATH, fullPathOrg);
               } else {
                    localStorage.setItem(LOCAL_DIRECT_PATH, fullPathIndividual);
               }
          }

          if (redirect) {
               window.location.replace(AUTH_PATH.LOGIN);
          } else {
               callBack();
          }
     });
};
